var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconFitnessDumbbell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.318 1.189a1.5 1.5 0 0 0 0 2.121l4.371 4.371a1.5 1.5 0 0 0 2.122-2.121l-4.372-4.371a1.5 1.5 0 0 0-2.121 0Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.075 1.188a1.5 1.5 0 0 0 0 2.122l8.615 8.615A1.5 1.5 0 1 0 22.811 9.8L14.2 1.188a1.5 1.5 0 0 0-2.125 0ZM1.189 16.318a1.5 1.5 0 0 1 2.122 0l4.371 4.371a1.5 1.5 0 0 1-2.121 2.121l-4.372-4.371a1.5 1.5 0 0 1 0-2.121Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.189 12.074a1.5 1.5 0 0 1 2.121 0l8.615 8.615A1.5 1.5 0 0 1 9.8 22.811L1.189 14.2a1.5 1.5 0 0 1 0-2.126Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m6.557 15.321 8.764-8.764 2.121 2.121-8.764 8.765z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconFitnessDumbbell);
export default __webpack_public_path__ + "static/media/streamline-icon-fitness-dumbbell.61d8c16c.svg";
export { ForwardRef as ReactComponent };